<template>
<div>
    <slot v-bind="{
        active, isActiveClassic, isActiveForest, changeToClassic, changeToForest, filterClassic, filterForest
    }"></slot>
</div>
</template>
<script>
import EventBus from '../utils/eventBus';
const Houses = {
    classic: 1,
    forest: 2
};

export default {
    name: 'HousesTeaser',

    data: () => ({
        active: Houses.classic,
    }),

    computed: {
        isActiveClassic() {
            return this.active === Houses.classic;
        },
        isActiveForest() {
            return this.active === Houses.forest;
        }
    },

    methods: {
        change(type) {
            this.active = type;
        },
        filter(type) {
            let payload = {
                house: type,
                type: '',
                fitting: ''
            };
            EventBus.$emit('rooms-list-update', payload);
        },
        filterClassic() {
            this.filter(Houses.classic);
        },
        filterForest() {
            this.filter(Houses.forest);
        },
        changeToClassic() {
            this.change(Houses.classic);
        },
        changeToForest() {
            this.change(Houses.forest);
        },
    },
}
</script>
